"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _vlpTableCarousel = _interopRequireDefault(require("../vlp-table-carousel.css"));
var TwoRowsCard = function TwoRowsCard(_ref) {
  var firstRowLabel = _ref.firstRowLabel,
    firstRowTitle = _ref.firstRowTitle,
    secondRowTitle = _ref.secondRowTitle,
    secondRowAltText = _ref.secondRowAltText,
    secondRowImage = _ref.secondRowImage,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].card + " " + _vlpTableCarousel["default"].twoRowsCard
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].topRow
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: firstRowLabel,
    className: _vlpTableCarousel["default"].label,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: firstRowTitle,
    className: _vlpTableCarousel["default"].title,
    tag: "p",
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].bottomRow
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _vlpTableCarousel["default"].cardImage,
    src: secondRowImage,
    alt: secondRowAltText
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: secondRowTitle,
    className: _vlpTableCarousel["default"].title,
    tag: "p",
    disclaimerData: disclaimerData
  })));
};
var _default = TwoRowsCard;
exports["default"] = _default;